export const getJurisdictionPathParams = () => {
  const { pathname } = window.location;
  const [, , , name, state] = pathname.split('/');
  const combined = `${name}/${state}`;

  return {
    jurisdictionPath: combined,
  };
};
